module.exports = __webpack_public_path__ + "img/hp-one-1.ab63ddc3.jpg";